import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import { Grid, Typography, Button, withStyles, Menu, ListItemIcon, ListItemText, MenuItem, ButtonGroup } from '@material-ui/core'
import useRouter from 'utils/useRouter'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import SaveIcon from '@material-ui/icons/Save'
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn'
import VisibilityIcon from '@material-ui/icons/Visibility'
import VpnKeyIcon from '@material-ui/icons/VpnKey'
import CircularProgress from '@material-ui/core/CircularProgress'
import { useExameRealizadoService } from 'hooks/useExameRealizadoService'
import { Breadcrumbs } from '../../../../components'
import { ConfirmarIdentidade } from 'components/ConfirmarIdentidade'

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(3),
  },
  headerTitleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingBottom: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  pageIndicator: {
    width: '4px',
    height: '24px',
    borderRadius: '2px',
    background: `linear-gradient(180deg, ${theme.palette.primary.main}, ${theme.palette.primary.light})`,
    marginRight: theme.spacing(1.5),
    flexShrink: 0,
  },
  titleTypography: {
    fontWeight: 700,
    color: theme.palette.text.primary,
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    fontSize: '1rem',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}))

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
))

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.secondary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem)

export const HeaderEdicaoExame = (props) => {
  const { className, errata, documentoState, setOpenUpload, fotosDocumentoState, titulo, isEditorDocumento, isFormularioInvalido, formAnaliseNecropapiloscopica, ...rest } = props
  const exameRealizadoService = useExameRealizadoService()
  const router = useRouter()
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)

  const [disableButtonSalvar, setDisableButtonSalvar] = useState(false)
  const [disableButtonVisualizar, setDisableButtonVisualizar] = useState(false)
  const [disableButtonFinalizar, setDisableButtonFinalizar] = useState(true)
  const [disableButtonAssinar, setDisableButtonAssinar] = useState(false)
  const [abrirConfirmarIdentidade, setConfirmarIdentidade] = useState(false)

  const exameRealizado = useSelector((state) => state.editorExameRealizado.exameRealizadoEditorDocumento)
  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleClickBotaoAcoes = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleSalvarDocumento = useCallback(async () => {
    await exameRealizadoService.salvarDocumento(exameRealizado.id, documentoState, fotosDocumentoState, setDisableButtonSalvar, false)
    exameRealizadoService.listarExameRealizadoEditorGlobal(exameRealizado.id)
  }, [exameRealizado, documentoState, fotosDocumentoState])

  const handleVisualizarDocumento = async () => {
    exameRealizadoService.downloadArquivoDocumento(exameRealizado.id, exameRealizado.numeroExame, setDisableButtonVisualizar, false)
  }

  const handleFinalizarDocumento = useCallback(async () => {
    exameRealizadoService.finalizarDocumento(exameRealizado.id, exameRealizado.id_exame_solicitado, setDisableButtonFinalizar)
  }, [exameRealizado])

  const handleAssinarExame = async () => {
    await exameRealizadoService.salvarDocumento(exameRealizado.id, documentoState, fotosDocumentoState, setDisableButtonSalvar, true)
    await exameRealizadoService.assinarExame(exameRealizado.id)
    exameRealizadoService.listarExameRealizadoEditorGlobal(exameRealizado.id)
  }

  const handleOpenConfirmarIdentidade = (rowData) => {
    setConfirmarIdentidade(true)
  }

  useEffect(() => {
    let qtdAssinaturas = 0

    exameRealizado.exRealUsus?.forEach((exRealUsuarios) => {
      if (exRealUsuarios.assinatura) {
        qtdAssinaturas++
      }
    })

    if (exameRealizado.exRealUsus?.length === qtdAssinaturas) {
      setDisableButtonFinalizar(false)
    } else {
      setDisableButtonFinalizar(true)
    }
  }, [exameRealizado])

  const handleAssinarEFinalizarErrata = useCallback(async () => {
    const filiacoes = []
    Object.keys(formAnaliseNecropapiloscopica.formState.values).forEach((key) => {
      if (key.indexOf('filiacao') !== -1) {
        filiacoes.push(formAnaliseNecropapiloscopica.formState.values[key])
      }
    })
    const dadosIdentificacao = {
      ...formAnaliseNecropapiloscopica.formState.values,
      filiacoes,
    }
    await exameRealizadoService.assinarEFinalizarErrata(exameRealizado.id, documentoState, dadosIdentificacao, setDisableButtonFinalizar)
    router.history.push(`/casos/caso/solicitacao/exameSolicitado/detalhar/${exameRealizado.id_exame_solicitado}`)
  }, [documentoState, exameRealizado, formAnaliseNecropapiloscopica])

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <div style={{ marginBottom: '8px' }}>
        <Breadcrumbs props={props} pathname={router.location.pathname} />
      </div>
      <Grid 
        alignItems="center" 
        container 
        justifyContent="space-between" 
        spacing={2}
        className={classes.headerTitleContainer}
      >
        <Grid item style={{ display: 'flex', alignItems: 'center' }}>
          <div className={classes.pageIndicator} />
          <Typography component="h1" className={classes.titleTypography}>
            {titulo}
          </Typography>
        </Grid>
        <Grid item>
          {isEditorDocumento && (
            <div>
              <ButtonGroup aria-controls="customized-menu" aria-haspopup="true" variant="contained" color="primary" onClick={handleClickBotaoAcoes}>
                <Button>Ações</Button>
                <Button color="primary" size="small" aria-label="select merge strategy" aria-haspopup="menu">
                  <ArrowDropDownIcon />
                </Button>
              </ButtonGroup>
              {!errata && (
                <StyledMenu id="customized-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
                  <StyledMenuItem disabled={disableButtonVisualizar} onClick={handleVisualizarDocumento}>
                    <ListItemIcon>
                      <VisibilityIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Visualizar documento</ListItemText>
                    {disableButtonVisualizar && <CircularProgress size={24} className={classes.buttonProgress} />}
                  </StyledMenuItem>
                  <StyledMenuItem disabled={disableButtonSalvar} onClick={handleSalvarDocumento}>
                    <ListItemIcon>
                      <SaveIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Salvar documento</ListItemText>
                    {disableButtonSalvar && <CircularProgress size={24} className={classes.buttonProgress} />}
                  </StyledMenuItem>
                  <StyledMenuItem disabled={disableButtonAssinar} onClick={() => handleOpenConfirmarIdentidade()}>
                    <ListItemIcon>
                      <VpnKeyIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Assinar exame</ListItemText>
                  </StyledMenuItem>
                  <StyledMenuItem disabled={disableButtonFinalizar} onClick={handleFinalizarDocumento}>
                    <ListItemIcon>
                      <AssignmentTurnedInIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Finalizar documento</ListItemText>
                  </StyledMenuItem>
                </StyledMenu>
              )}

              {errata && (
                <StyledMenu id="customized-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
                  <StyledMenuItem onClick={handleOpenConfirmarIdentidade} disabled={isFormularioInvalido}>
                    <ListItemIcon>
                      <SaveIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Assinar e Finalizar</ListItemText>
                    {disableButtonSalvar && <CircularProgress size={24} className={classes.buttonProgress} />}
                  </StyledMenuItem>
                </StyledMenu>
              )}
            </div>
          )}
        </Grid>
        {errata ? (
          <ConfirmarIdentidade aberto={abrirConfirmarIdentidade} setAberto={setConfirmarIdentidade} callback={handleAssinarEFinalizarErrata} titulo="Assinar Exame" />
        ) : (
          <ConfirmarIdentidade aberto={abrirConfirmarIdentidade} setAberto={setConfirmarIdentidade} callback={handleAssinarExame} titulo="Assinar Exame" />
        )}
      </Grid>
    </div>
  )
}
